import React, { useState } from "react";

const CloseIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const MenuPopup = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
    
    return (
        <>
            {/* Backdrop */}
            <div 
            style={{
                fontFamily: 'Poppins, sans-serif'
            }}
                className="fixed inset-0 z-40 animate-fade-in"
                onClick={onClose}
            />
            
            {/* Popup Box */}
            <div 
                className="fixed top-16 left-5 z-50 animate-slide-down"
                style={{ width: 'auto', minWidth: '120px', maxWidth: '380px' }}
            >
                <div 
                    className="rounded-xl shadow-2xl px-8 py-2 relative"
                    style={{ 
                        backgroundColor: '#FF8879',
                        border: '1px solid #000000',
                        boxShadow: '1px 4px 1px 1px black'

                    }}
                >
                    <nav className="flex flex-col md:flex-row items-center justify-center gap-8">
                        <a 
                            href="/" 
                            className="text-xl text-white font-bold hover:opacity-80 transition-opacity"
                            onClick={onClose}
                        >
                            HOME
                        </a>
                        <div className="w-px hidden md:block h-8 bg-white"></div>
                        <a 
                            href="/ticket" 
                            className="text-xl text-white font-bold hover:opacity-80 transition-opacity"
                            onClick={onClose}
                        >
                            TICKETS
                        </a>
                        <div className="w-px h-8 hidden md:block bg-white"></div>
                        <a 
                            href="/faq" 
                            className="text-xl text-white font-bold hover:opacity-80 transition-opacity"
                            onClick={onClose}
                        >
                            FAQ
                        </a>
                    </nav>
                </div>
            </div>
        </>
    );
};

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <>
            <header
                style={{
                    backgroundColor: "#440A06",
                    backgroundSize: "cover",
                    backgroundImage: "url('/pattern footer.png')"
                }}
                className="flex items-center justify-between px-8 py-3 shadow-md fixed top-0 left-0 w-full z-20"
            >
                {/* Left - Hamburger Menu (ALL SCREENS) */}
                <div className="flex items-center" style={{ width: '80px' }}>
                    <button
                        className="text-white focus:outline-none"
                        onClick={() => setMenuOpen(true)}
                    >
                        <img
                            src="/hamburger.png"
                            alt="Menu"
                            className="h-9 md:h-14"
                        />
                    </button>
                </div>

                {/* Center - HOME button (Mobile only) */}
                <div className="flex justify-center sm:hidden" style={{ flex: '1' }}>
                    <a href="/">
                        <img
                            src="/HOME BUTTON.png"
                            alt="Home"
                            className="h-8"
                        />
                    </a>
                </div>

                {/* Center - HOME button (Desktop only) */}
                <div className="hidden sm:flex sm:justify-center" style={{ flex: '1' }}>
                    <a href="/">
                        <img
                            src="/HOME BUTTON.png"
                            alt="Home"
                            className="h-[58px]"
                        />
                    </a>
                </div>

                {/* Right - TICKET button (ALL SCREENS) */}
                <div className="flex items-center justify-end" style={{ width: '80px' }}>
                    <a href="https://in.bookmyshow.com/events/bandland-2026/ET00466059">
                        <img
                            src="/tickets. button.png"
                            alt="Ticket"
                            className="h-7 md:h-[46px]"
                        />
                    </a>
                </div>
            </header>

            <MenuPopup isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
            
            <style>{`
                .animate-slide-down {
                    animation: slideDown 0.3s ease-out;
                }
                @keyframes slideDown {
                    from {
                        transform: translateY(-20px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                
                .animate-fade-in {
                    animation: fadeIn 0.3s ease-out;
                }
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            `}</style>

            {/* Spacer div to prevent content from hiding under fixed header */}
            <div
                className="w-full h-[59px] md:h-[82px]"
                style={{
                  
                    backgroundColor: "#440A06",
                    backgroundImage: "url('/pattern footer.png')",
                    backgroundSize: "cover"
                }}
            />
        </>
    );
}